import { differenceInDays, endOfDay } from "date-fns";

export function isExpired(date: Date | string): boolean | null {
	if (!date) {
		return null
	}

	const parsedDate = new Date(date);
	if (parsedDate <= new Date('1900-01-01')) {
		return null;
	}

	const today = endOfDay(new Date());
	return today > endOfDay(parsedDate);
}

export function isExpiringSoon(date: Date | string): boolean | null {
	if (!date) {
		return null
	}

	const parsedDate = new Date(date);
	if (parsedDate <= new Date('1900-01-01')) {
		return null;
	}

	const today = endOfDay(new Date());
	const daysUntilExpiration = differenceInDays(endOfDay(parsedDate), today);
	if (daysUntilExpiration >= 0 && daysUntilExpiration <= 30) {
		return true;
	}

	return false;
}